import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Moon, Sun, Globe, Menu, X } from 'lucide-react'
import { useApp } from '../context/AppContext'
import { t } from '../i18n'

export default function Navbar() {
  const { lang, setLang, dark, setDark } = useApp()
  const location = useLocation()
  const [menuOpen, setMenuOpen] = useState(false)

  const navLinks = [
    { to: '/', label: t(lang, 'home') },
    { to: '/about', label: t(lang, 'about') },
    { to: '/clients', label: t(lang, 'clients') },
    { to: '/articles', label: t(lang, 'articles') },
    { to: '/contact', label: t(lang, 'contact') },
  ]

  const isActive = (path: string) => location.pathname === path

  return (
    <nav className="navbar">
      <div className="nav-inner">
        <Link to="/" className="nav-logo" onClick={() => setMenuOpen(false)}>
          <img src="/logo.png" alt="شليل لوجو" className="logo-img" />
          <span className="logo-text">
            <span className="logo-main">{lang === 'ar' ? 'شليل' : 'Shalil'}</span>
            <span className="logo-sub">{lang === 'ar' ? 'للخدمات اللوجستية' : 'Logistics'}</span>
          </span>
        </Link>

        <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
          {navLinks.map((link) => (
            <li key={link.to}>
              <Link
                to={link.to}
                className={`nav-link ${isActive(link.to) ? 'active' : ''}`}
                onClick={() => setMenuOpen(false)}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="nav-actions">
          <button
            className="nav-btn icon-btn"
            onClick={() => setDark(!dark)}
            title={dark ? t(lang, 'toggleLight') : t(lang, 'toggleDark')}
            aria-label="toggle theme"
          >
            {dark ? <Sun size={18} /> : <Moon size={18} />}
          </button>

          <button
            className="nav-btn lang-btn"
            onClick={() => setLang(lang === 'ar' ? 'en' : 'ar')}
            title={t(lang, 'langToggle')}
            aria-label="toggle language"
          >
            <Globe size={16} />
            <span>{t(lang, 'langToggle')}</span>
          </button>

          <button
            className="mobile-menu-btn"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="toggle menu"
          >
            {menuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {menuOpen && <div className="nav-overlay" onClick={() => setMenuOpen(false)} />}
    </nav>
  )
}
